// extracted by mini-css-extract-plugin
module.exports = {"avatar_driver":"chat_avatar_driver__1Estm","attach_btn":"chat_attach_btn__1GPrw","attach_loader":"chat_attach_loader__EyQQj"};